class MobileSwiperBase extends HTMLElement {
  constructor() {
    super();
    this.swipers = [];
    this.onResize = this.onResize.bind(this);
  }

  connectedCallback() {
    this.onResize();
    window.addEventListener('resize', this.onResize);
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.onResize);
    this.destroyAll();
  }

  onResize() {
    const isMobile = window.innerWidth < 768;
    if (isMobile && this.swipers.length === 0) {
      this.initAll();
    } else if (!isMobile && this.swipers.length > 0) {
      this.destroyAll();
    }
  }

  // Override in subclass — return array of { el, options }
  getSwiperConfigs() {
    return [];
  }

  initAll() {
    this.getSwiperConfigs().forEach(({ el, options }) => {
      if (!el) return;
      this.swipers.push(new Swiper(el, options));
    });
  }

  destroyAll() {
    this.swipers.forEach((s) => s.destroy(true, true));
    this.swipers = [];
  }
}

if (!customElements.get('universal-blocks-section')) {
  class UniversalBlocksSection extends MobileSwiperBase {
    getSwiperConfigs() {
      return [...this.querySelectorAll('.universal-blocks__swiper')].map((el) => ({
        el,
        options: {
          slidesPerView: 1,
          spaceBetween: 16,
          grabCursor: true,
          pagination: {
            el: el.querySelector('.swiper-pagination'),
            clickable: true,
          },
        },
      }));
    }
  }

  customElements.define('universal-blocks-section', UniversalBlocksSection);
}

if (!customElements.get('universal-explanation-slider')) {
  class UniversalExplanationSlider extends MobileSwiperBase {
    getSwiperConfigs() {
      const el = this.querySelector('.universal-explanation__swiper');
      return el
        ? [{ el, options: { slidesPerView: 1.2, centeredSlides: true, spaceBetween: 16, loop: true, grabCursor: true, initialSlide: 1 } }]
        : [];
    }
  }

  customElements.define('universal-explanation-slider', UniversalExplanationSlider);
}
